import { Link } from "react-router-dom";
import { P, SVG } from "../../AbstractElements";
import { SearchbarEmptyText } from "../../Constant";
import { SearchSuggestionListProp } from "../../Type/HeaderType";

const SearchSuggestionList = ({ setSuggestionOpen, suggestion, setSearchValue }: SearchSuggestionListProp) => {
  const handleLinkClick = () => {
    setSuggestionOpen(false);
    setSearchValue("");
    document.body.classList.remove("offcanvas");
  };

  return (
    <>
      {suggestion.map((item: any, i: number) => (
        <div className="ProfileCard u-cf" key={i}>
          <div className="ProfileCard-details">
            <div className="ProfileCard-realName">
              <Link className="realname  w-auto d-flex justify-content-start gap-2" to={item.url} onClick={handleLinkClick}>
                <SVG iconId={`stroke-${item.icon}`} />
                {item.title}
              </Link>
            </div>
          </div>
        </div>
      ))}
      {!suggestion.length && <P>{SearchbarEmptyText}</P>}
    </>
  );
};

export default SearchSuggestionList;
